import React from 'react'
import { isEmpty } from 'lodash'
import { Container, Alert, bannerStyles } from '@paypalcorp/pp-react'

import { useApplicationContext } from '../../../../../provider'

import './style.css'

const NotificationBanner = ({ handleDismiss }) => {
  // Get the user context to see if logged in - we use this to control margin
  const { user, notificationBanner } = useApplicationContext()
  const userLoggedOut = !isEmpty(user) && !user.loggedIn

  if (!notificationBanner.enabled || notificationBanner.enabled === 'false') {
    return null
  }
  return (
    <section
      className={
        !userLoggedOut
          ? 'notification-banner notification-banner_loggedIn'
          : 'notification-banner'
      }
    >
      <Container className="banner-wrapper">
        <Alert
          type="info"
          className="alert-banner"
          closeButton={{
            'aria-label': 'dismiss alert',
            onClick: () => handleDismiss(),
          }}
        >
          <div
            dangerouslySetInnerHTML={{ __html: notificationBanner.message }}
          />
          {notificationBanner.link && (
            <a
              href={notificationBanner.link.href}
              rel={notificationBanner.link.rel}
              target={notificationBanner.link.target}
              title={notificationBanner.link.title}
            >
              {notificationBanner.link.text}
            </a>
          )}
          .
        </Alert>
      </Container>
    </section>
  )
}

export default NotificationBanner
